export const M_SET_TOUR_INFO = "M_SET_TOUR_INFO";
export const M_SET_GDS_PARAM = "M_SET_GDS_PARAM";
export const M_SET_API_URL = "M_SET_API_URL";
export const M_SET_API_ORIGIN = "M_SET_API_ORIGIN";
export const M_SET_HOTELS_FOR_MAP = "M_SET_HOTELS_FOR_MAP";
export const M_SET_AGREE_TO_RECEIVE = "M_SET_AGREE_TO_RECEIVE";
